import React, {useState, useEffect, useContext} from 'react';
import CommandsContext from '../../../context/commandsContext';
import useKeyPress from '../../../hooks/useKeyPress';
import FullBodyContentView from '../../views/fullBodyContentView';

function GasLinear({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const {onUpdateCommands} = useContext(CommandsContext);

  useEffect(() => {
    if (!leftPress) return;
    onExit();
  }, [leftPress]);

  useEffect(() => {
    setTimeout(() => {
      onUpdateCommands({onLeft: onExit});
    });
  }, [onExit]);

  return (
    <FullBodyContentView
      title="Gas Linearization"
      fullCaption="Enable/Disable...........Off................. 
      Corrected Flow...........0.0f.gram/s....
      Correction Factor........0.0f...............
      Uncorrected Factor.....0.0f.gram/s...
      Cal Pressure Comp....On.................
      "
    />
  );
}

export default GasLinear;
